module.exports = __webpack_public_path__ + "static/media/AboutUs-img.9651f104.png";